<template>
    <v-form ref="form" v-model="valid" :disabled="loading" class="d-flex">
        <div>
            <PercentInput
                class="mr-2"
                label="venta"
                v-model="fields.percent_venta"
                :rules="rules.percent_venta"
                @change="changed('percent_venta')"
                dense/>
        </div>
        <div>
            <PercentInput
                label="premio"
                v-model="fields.percent_premio"
                :rules="rules.percent_premio"
                @change="changed('percent_premio')"
                dense/>
        </div>
    </v-form>
</template>
<script>
import Form from '@/mixins/form';

export default {
    mixins: [Form],
    props: {},
    data: function () {
        return {
            defaultFields: {
                percent_venta: 0,
                percent_premio: 0,
            },
            rules: {
                percent_venta: [
                    v => !!v || 'No puede ser 0'
                ],
                percent_premio: [
                    v => !!v || 'No puede ser 0'
                ],
            }
        };
    },
}
</script>